<template>
    <div>
        <div class="search-box">
            <p>立项年度：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY年'
                v-model="searchFrom.decideDate" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne"/>
            <p>项目类别：</p>
            <a-select 
                class="input-box" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="searchFrom.consProjectTypeCode">
                <a-select-option v-for="(item,index) in xmlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>课程名称：</p>
            <a-input class="input-box" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:build:add')>-1" icon="plus" class="btn" @click="$router.push('/admin/undergraduate/research/build/info?type=add')">新增</a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:build:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/undergraduate/research/build/info?type=update&id='+selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:culture:build:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:culture:build:query')>-1" @click="selectedRowKeys[0] == null ? selectedCheck() :$router.push('/admin/undergraduate/research/build/info?type=look&id='+selectedRowKeys[0])" >查看详情</a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <template slot="consProjectTypeCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.consProjectTypeCode" disabled>
                    <a-select-option v-for="(item,index) in xmlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="courseAttrCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.courseAttrCode" disabled>
                    <a-select-option v-for="(item,index) in kcsxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <!-- <template slot="id" slot-scope="text">
                <a class="action-btn"  @click="$router.push('/admin/undergraduate/research/build/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$router.push('/admin/undergraduate/research/build/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <p class="table-tips">更新截至日期：{{lastTime}}</p>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,lastUpdateTime } from '@/baseAPI/undergraduate/culture/build'
    import { selectedCheck } from '@/baseAPI/util'

    const columns = [
        {
            title: '序号',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '立项年度',
            dataIndex: 'decideDate',
            align:'center'
        },
        {
            title: '项目类别',
            dataIndex: 'consProjectTypeCode',
            scopedSlots: { customRender: 'consProjectTypeCode' },
            align:'center'
        },
        {
            title: '课程号',
            dataIndex: 'courseNo',
            align:'center'
        },
        {
            title: '课程名称',
            dataIndex: 'courseName',
            align:'center'
        },
        {
            title: '课程属性',
            dataIndex: 'courseAttrCode',
            scopedSlots: { customRender: 'courseAttrCode' },
            align:'center'
        },
        {
            title: '课程主管',
            dataIndex: 'courseDirectorName',
            align:'center'
        },
        {
            title:'截图是否上传',
            dataIndex:'files',
            align:'center',
            customRender: (text, row, index) => {
                return text == null ?'-':'是'
            },
        },

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    consProjectTypeCode:'',
                    courseName:'',
                },
                xmlbArr:[],
                kcsxArr:[],
                lastTime:'',
                yearShowOne:false,
                year:null,
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'KCJSXMLB',status:true}).then(res=>{
                this.xmlbArr=res.data.dicts;
            })
            getDicts({dataCode:'KCSX',status:true}).then(res=>{
                this.kcsxArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
                lastUpdateTime().then(res=>{
                    this.lastTime=res.data
                })
            },
            handSearch(value){
                if(value!=''){
                    this.searchFrom.consProjectTypeCode=value
                }
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程建设项目成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.searchFrom.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
